<template>
  <div class="flex-container">
    <el-breadcrumb class="flex-item" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item class="text-center" :to="{ path: '/sys/channel/list' }"
      >渠道申报修改</el-breadcrumb-item>
    </el-breadcrumb>
    <el-form
        class="flex-item role-form"
        ref="validateForm"
        :model="form"
        size="mini"
        :rules="rules"
        :validate-on-rule-change="false"
        label-width="200px"
    >
      <el-row>
        <el-collapse v-model="activeNames" @change="handleChange">
          <!--<el-collapse-item title="初审情况" name="4">
            <el-col :span="8">
              <el-form-item label="审核状态:" prop="technicalPerson">
                <el-input type="text" v-model="inputValue3" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="审核意见:" prop="technicalPerson">
                <el-input type="textarea" :rows="2" v-model="inputValue4" readonly></el-input>
              </el-form-item>
            </el-col>
            </el-collapse-item>
          <el-collapse-item title="复审情况" name="4">
            <el-col :span="8">
              <el-form-item label="审核状态:" prop="technicalPerson">
                <el-input type="text" v-model="inputValue13" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="审核意见:" prop="technicalPerson">
                <el-input type="textarea" :rows="2" v-model="inputValue14" readonly></el-input>
              </el-form-item>
            </el-col>
          </el-collapse-item>-->

          <el-collapse-item title="渠道申报基础信息" name="1">
            <el-col :span="8">
              <el-form-item label="统一社会信用代码:" prop="channelName">
                <el-input v-model="form.technicalPhone"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="公司名称:" prop="channelName">
                <el-input v-model="form.channelName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="公司官网域名:" prop="channelName1">
                <el-input v-model="form.channelName1"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="渠道编码:" prop="channelName">
                <el-input v-model="form.channelName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="渠道名称:" prop="channelName">
                <el-input v-model="form.channelName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="渠道简称:" prop="channelName">
                <el-input v-model="form.channelName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="申报主体类别:" prop="channelName">
                <el-select v-model="value" placeholder="请选择">
                  <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="主营品牌:" prop="channelName1">
                <el-input v-model="form.channelName1"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="注册资金(万元):" prop="technicalEmail">
                <el-input v-model="form.technicalEmail"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="法定代表人:" prop="channelName">
                <el-input v-model="form.technicalPhone"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="法定代表人联系电话:" prop="technicalEmail">
                <el-input v-model="form.technicalEmail"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="企业银行开户行名称:" prop="channelName">
                <el-input v-model="form.channelName1"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="企业银行帐号:" prop="channelName">
                <el-input v-model="form.channelName1"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="经营模式:" prop="channelName">
                <el-select v-model="form.businessModel" placeholder="请选择">
                  <el-option
                      v-for="item in businessModels"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="线上平台名称:" prop="domain">
                <el-input v-model="form.domain"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="2025年企业销售额(万元):" prop="technicalEmail">
                <el-input v-model="form.technicalEmail"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="企业注册地址:" prop="channelNo">
                <el-input v-model="form.channelNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="注册地所在区:" prop="companyName">
                <el-input v-model="form.companyName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="企业咨询电话:" prop="channelName1">
                <el-input v-model="form.channelName1"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="商务联系人姓名:" prop="technicalEmail">
                <el-input v-model="form.technicalEmail"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="商务联系人电话:" prop="technicalEmail">
                <el-input v-model="form.technicalEmail"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="商务联系人邮箱:" prop="technicalEmail">
                <el-input v-model="form.technicalEmail"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="技术联系人姓名:" prop="technicalEmail">
                <el-input v-model="form.technicalEmail"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="技术联系人电话:" prop="technicalEmail">
                <el-input v-model="form.technicalEmail"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="技术联系人邮箱:" prop="technicalEmail">
                <el-input v-model="form.technicalEmail"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="经营范围:" prop="businessEmail">
                <el-input v-model="form.domain"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="企业简介:" prop="technicalPerson">
                <el-input type="textarea" :rows="2" v-model="form.dynamicDml"></el-input>
              </el-form-item>
            </el-col>
          </el-collapse-item>
          <el-collapse-item title="渠道申报材料上传" name="2">
            <el-col :span="12">
              <el-form-item label="商户信息汇总表:" prop="technicalEmail">
                <el-upload
                    class="upload-demo"
                    action="https://jsonplaceholder.typicode.com/posts/"
                    :on-preview="handlePreview"
                    :on-remove="handleRemove"
                    :before-remove="beforeRemove"
                    multiple
                    :limit="3"
                    :on-exceed="handleExceed"
                    :file-list="fileList">
                  <el-button size="mini" type="primary">下载模板</el-button>
                  <el-button size="mini" type="primary">上传文件</el-button>
                </el-upload>
                <el-link type="primary">商户信息汇总表.xls</el-link>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="门店信息汇总表:" prop="technicalEmail">
                <el-upload
                    class="upload-demo"
                    action="https://jsonplaceholder.typicode.com/posts/"
                    :on-preview="handlePreview"
                    :on-remove="handleRemove"
                    :before-remove="beforeRemove"
                    multiple
                    :limit="3"
                    :on-exceed="handleExceed"
                    :file-list="fileList">
                  <el-button size="mini" type="primary">下载模板</el-button>
                  <el-button size="mini" type="primary">上传文件</el-button>
                </el-upload>
                <el-link type="primary">门店信息汇总表.xls</el-link>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="渠道营业执照复印件:" prop="technicalEmail">
                <el-upload
                    class="upload-demo"
                    action="https://jsonplaceholder.typicode.com/posts/"
                    :on-preview="handlePreview"
                    :on-remove="handleRemove"
                    :before-remove="beforeRemove"
                    multiple
                    :limit="3"
                    :on-exceed="handleExceed"
                    :file-list="fileList">
                  <el-button size="mini" type="primary">上传文件</el-button>
                </el-upload>
                <el-link type="primary">渠道营业执照复印件.pdf</el-link>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="渠道企业《信用信息报告》:" prop="technicalEmail">
                <el-upload
                    class="upload-demo"
                    action="https://jsonplaceholder.typicode.com/posts/"
                    :on-preview="handlePreview"
                    :on-remove="handleRemove"
                    :before-remove="beforeRemove"
                    multiple
                    :limit="3"
                    :on-exceed="handleExceed"
                    :file-list="fileList">
                  <el-button size="mini" type="primary">上传文件</el-button>
                </el-upload>
                <el-link type="primary">渠道企业《信用信息报告》.pdf</el-link>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="渠道承诺函:" prop="technicalEmail">
                <el-upload
                    class="upload-demo"
                    action="https://jsonplaceholder.typicode.com/posts/"
                    :on-preview="handlePreview"
                    :on-remove="handleRemove"
                    :before-remove="beforeRemove"
                    multiple
                    :limit="3"
                    :on-exceed="handleExceed"
                    :file-list="fileList">
                  <el-button size="mini" type="primary">上传文件</el-button>
                </el-upload>
                <el-link type="primary">渠道承诺函.pdf</el-link>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="渠道政策实施方案:" prop="technicalEmail">
                <el-upload
                    class="upload-demo"
                    action="https://jsonplaceholder.typicode.com/posts/"
                    :on-preview="handlePreview"
                    :on-remove="handleRemove"
                    :before-remove="beforeRemove"
                    multiple
                    :limit="3"
                    :on-exceed="handleExceed"
                    :file-list="fileList">
                  <el-button size="mini" type="primary">上传文件</el-button>
                </el-upload>
                <el-link type="primary">渠道政策实施方案.pdf</el-link>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="银行开户许可证复印件:" prop="technicalEmail">
                <el-upload
                    class="upload-demo"
                    action="https://jsonplaceholder.typicode.com/posts/"
                    :on-preview="handlePreview"
                    :on-remove="handleRemove"
                    :before-remove="beforeRemove"
                    multiple
                    :limit="3"
                    :on-exceed="handleExceed"
                    :file-list="fileList">
                  <el-button size="mini" type="primary">上传文件</el-button>
                </el-upload>
                <el-link type="primary">银行开户许可证复印件.pdf</el-link>
              </el-form-item>
            </el-col>
          </el-collapse-item>
          <el-collapse-item title="商户申报材料上传" name="3">
            <el-col :span="24">
              <el-form-item label="" prop="technicalEmail">
                <el-upload
                    class="upload-demo"
                    action="https://jsonplaceholder.typicode.com/posts/"
                    :on-preview="handlePreview"
                    :on-remove="handleRemove"
                    :before-remove="beforeRemove"
                    multiple
                    :limit="3"
                    :on-exceed="handleExceed"
                    :file-list="fileList">
                  <el-button size="mini" type="primary">上传文件</el-button>
                  <div slot="tip" class="el-upload__tip" style="color: red">说明：文件上传格式为.zip，示例：
                    <br>商户A，文件目录结构为：商户申报材料/商户A/营业执照复印件.pdf
                    、企业《信用信息报告》.pdf、同意函.pdf、承诺函.pdf
                    <br>商户B，文件目录结构为：商户申报材料/商户B/营业执照复印件.pdf
                    、企业《信用信息报告》.pdf、同意函.pdf、承诺函.pdf</div>
                </el-upload>
                <el-link type="primary">商户申报材料.zip</el-link>
              </el-form-item>
            </el-col>
          </el-collapse-item>
        </el-collapse>
      </el-row>
    </el-form>
    <div class="flex-item" style="text-align: center">
      <el-button size="mini" @click="back">返回</el-button>
      <el-button size="mini" type="primary" @click="save">保存</el-button>
    </div>
  </div>
</template>

<script>
import {
  list
} from "@/api/system/linXuanChannel/linXuanChannel";

export default {
  name: "index",
  data() {
    return {
      businessModels: [{
        value: '0',
        label: '线上'
      }, {
        value: '1',
        label: '线下'
      }],
      options: [{
        value: '0',
        label: '电商平台'
      }, {
        value: '1',
        label: '开展自营业务的电商企业'
      }, {
        value: '2',
        label: '线下收单机构或支付机构'
      }],
      checkList: ['选中且禁用','复选框 A'],
      disabledList: [
        { label: "是", value: "0" },
        { label: "否", value: "1" },
      ],
      rules: {
        channelName: [
          {trigger: "blur", required: true, message: "名称不能为空"},
        ],
        channelType: [
          {trigger: "blur", required: true, message: "类型不能为空"},
        ]
      },
      roleList: null,
      departmentList: null,
      id: null,
      load: false,
      tableLoading: false,
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableList: [],
      form: { roleIds: [], enable: "1" },
      isOneself: false,
      clickFlag: true,
      activeNames: ['1','2','3','4'],
      inputValue1:'首信用户',
      inputValue2:'2025-12-30 09:30:20',
      inputValue3:'不通过',
      inputValue4:'商户资料未按要求上传',
      inputValue11:'商务局用户',
      inputValue12:'2025-12-30 09:50:20',
      inputValue13:'通过',
      inputValue14:'同意'
    };
  },
  mounted() {
    if (this.$route.params.id) {
      this.form.id=this.$route.params.id;
      this.id=this.$route.params.id;
      getChannelInfo({ id: this.$route.params.id }).then((res) => {
        if (res.code == 200) {
          this.form = { ...res.data };
        } else {
          this.$message.error(res.message);
        }
      });
    }
  },
  methods: {
    handleChange(val) {
      console.log(val);
    },
    back() {
      this.$router.go(-1);
    },
    save() {
      this.$router.push({
        path: '/sys/channelDeclare/list'
      });
    },
    // send() {
    //     const fileExtension = str.substring(str.lastIndexOf(".") + 1);
    //     return fileExtension;
    // },
    // 提取文件后缀名
    getSuffix(str) {
      const fileExtension = str.substring(str.lastIndexOf(".") + 1);
      return fileExtension;
    },
  },
};
</script>

<style scoped>
.el-card {
  height: 100%;
}

.btn_box {
  text-align: right;
  margin-top: 8px;
  height: 40px;
}

.flex-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  text-align: left;
}

.flex-item:nth-child(1),
.flex-item:nth-child(3) {
  flex-grow: 0;
  flex-shrink: 0;
}

.flex-item:nth-child(2) {
  flex-grow: 1;
  flex-shrink: 1;
  overflow-y: auto;
}
.role-form {
  margin: 15px 0;
}
.el-form-item {
  margin-bottom: 7px;
}
.el-form-item__label {
  line-height: 1.0;
}
.el-form-item__content {
  line-height: 1.0;
}
/* 可选：调整标题栏布局，让按钮靠右 */
::v-deep .custom-accordion .el-accordion-item__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
/* 去掉默认标题文字的多余样式 */
::v-deep .custom-accordion .el-accordion-item__header-text {
  display: none;
}
</style>